// MIRRORS the backend mapper at
// `packages/cart_and_checkout/app/controllers/concerns/checkout_log_handler.rb`
// (REASON_CODE_EXACT_MAP, REASON_CODE_PATTERNS, RAW_LOG_CODE_MAX_LENGTH,
// reason_code_for, truncate_raw_log_code).
//
// MN-6309: frontend `track("checkout_error", ...)` calls bypass the backend's
// `notify_mixpanel_checkout_error` enrichment. Without this mapper, FE-emitted
// events would show up in Mixpanel with `log_code` set but `reason_code`
// missing — analyst dashboards keyed on reason_code would see them as null.
// Keep both lists in lockstep with the Ruby source above.

export const RAW_LOG_CODE_MAX_LENGTH = 100;

export const REASON_CODE_EXACT_MAP = {
  shipment_calculation_retry: "shipment_calc_failed",
  blank_shipments: "shipment_calc_failed",
  stock_unavailable: "item_unavailable"
};

// Patterns are evaluated in array order; first match wins. Order from
// most-specific to most-general so a narrow match isn't shadowed by a broader
// one earlier in the list.
export const REASON_CODE_PATTERNS = [
  [/address-(?:invalid|no-country)/i, "address_invalid"],
  [/(?:shipping|bill)-address/i, "address_invalid"],
  [/(?:po-box|not-shippable|unverified-shipping)/i, "address_invalid"],
  [/shipment-calculation/i, "shipment_calc_failed"],
  [/(?:stock-unavailable|blank-shipments|out-of-stock)/i, "item_unavailable"],
  [/cc-invalid|order-below-limit|payment-.*(?:declined|invalid|failed)/i, "payment_declined"],
  [/session-(?:expired|error)/i, "session_expired"]
];

const isBlank = value => value == null || value === "";

export const reasonCodeFor = logCode => {
  if (isBlank(logCode)) return "other";
  if (Object.prototype.hasOwnProperty.call(REASON_CODE_EXACT_MAP, logCode)) {
    return REASON_CODE_EXACT_MAP[logCode];
  }
  const match = REASON_CODE_PATTERNS.find(([pattern]) => pattern.test(logCode));
  return match ? match[1] : "other";
};

export const truncateRawLogCode = logCode => {
  if (isBlank(logCode)) return logCode;
  return String(logCode).slice(0, RAW_LOG_CODE_MAX_LENGTH);
};

export const enrichCheckoutErrorProperties = properties => {
  const logCode = properties?.log_code;
  return {
    ...properties,
    reason_code: reasonCodeFor(logCode),
    raw_log_code: truncateRawLogCode(logCode)
  };
};
